<template>
  <img :src="url" />
</template>

<script>
// this should be used in the animation commissioning page
export default {
  props: {
    src: String
  },
  data () {
    return {
      url: '',
      orgSrc: '',
      rollSrc: ''
    }
  },
  created () {
    this.setupUrl()
  },
  mounted () {
    this.$el.addEventListener('mouseenter', this.handleAnimate)
    this.$el.addEventListener('mouseleave', this.handleStop)
  },
  methods: {
    async handleAnimate () {
      this.url = this.rollSrc
    },
    async handleStop () {
      this.url = this.orgSrc
    },
    async setupUrl () {
      if(this.src.startsWith('/')) this.url = this.$k.imagebase + 'mediastore' + this.src
      else this.url = this.$k.imagebase + 'mediastore/' + this.src
      this.orgSrc = this.url
      this.rollSrc = this.orgSrc.replace('/static/','/')
    }

  },
  watch: {
    src () {
      this.setupUrl()
    }
  }
}
</script>

<style>

</style>